import { createSlice } from '@reduxjs/toolkit'
import { getIntSvcAxios, postIntSvcAxios } from "./axiosActions";


// const baseUrl =AppConfig.intsvcURL; 
const gmbSlice = createSlice({
    name: 'gmb',
    initialState: {
        tokenUrl: null,
        isGmbLoading: false,
        gmbReviews: [],
        code: null,
        accountsData: [],
        tokenData: [],
        gpsTokenUrl:null,
        gpsToken:null,
        isAuthenticated :false,
        location:{},
        categories:[],
        isReplyToReviewLoading: false
    },
    reducers: {
        reviewsSuccess: (state, action) => {
            let response = action.payload;
            if (response.statusCode == 501) {
                state.tokenUrl = response.data;
            }
            else if (response.statusCode == 200) {
                state.gmbReviews = response.data;
                state.tokenUrl= null
            }
        },
        getAccount: state => {
            state.isGmbLoading = true;
        },
        accountsSuccess: (state, action) => {
            let response = action.payload;
            state.accountsData = response;
            state.gmbReviews = [];
            state.isGmbLoading = false;
        },
        tokenUrlSuccess: (state, action) => { 
            state.tokenUrl = action.payload;
        },
        checkCompanyTokenSuccess: (state, action) => { 
            state.tokenData = action.payload?.data;
        },
        gpsTokenUrlSuccess: (state, action) => { 
            state.gpsTokenUrl = action.payload;
        },
        removeTokenSuccess: (state, action) => {
            let response = action.payload;
            if (response.statusCode == 200) {
                state.gmbReviews = [];
                state.accountsData = [];
            }
        },
        setGmbLoading: (state, action) => {
            state.isGmbLoading = action.payload;
        },
        
        getGPSTokenSucess: (state, action) => { 
            state.isAuthenticated = action.payload.statusCode===200;
            state.gpsToken=action.payload.data
        },
        getLocationSucess: (state, action) => { 
            state.location=action.payload.data
        },
        setLocation:(state, action)=>{
            state.location={}
        },

        getCategoriesSuccsess: (state, action) => { 
            state.categories=action.payload.data
        },
        replyToReviewLoading: (state) => {
            state.isReplyToReviewLoading = true;
        },
        replyToReviewSuccess: (state) => {
            state.isReplyToReviewLoading = false;
        },
        replyToReviewFailure: (state) => {
            state.isReplyToReviewLoading = false;
        },
    },
});

export const { reviewsSuccess, tokenSuccess, removeTokenSuccess, setGmbLoading, getAccount,
     accountsSuccess ,tokenUrlSuccess ,getGPSTokenSucess,gpsTokenUrlSuccess,checkCompanyTokenSuccess,
     getLocationSucess, setLocation,getCategoriesSuccsess, replyToReviewLoading, replyToReviewSuccess, replyToReviewFailure
    } = gmbSlice.actions;
export const gmbSelector = state => state.gmb;
export default gmbSlice.reducer

export function getAccounts() {
    return async dispatch => {
        dispatch(getAccount());
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/GetGMBLocations'
            const response = await getIntSvcAxios(url, { params: params });

            if (response) {
                dispatch(accountsSuccess(response));
            } else {
            }

        } catch (error) {
        }
    };
}
export function getTokenUrl() {
    return async dispatch => {
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/GetAuthenticationUrl' 
            const response = await getIntSvcAxios(url, { params: params });

            if (response) {
                dispatch(tokenUrlSuccess(response));
            } else {
            }

        } catch (error) {
        }
    };
}
export function getGPSTokenUrl() {
    return async dispatch => {
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/GetGPSAuthenticationUrl' 
            const response = await getIntSvcAxios(url, { params: params });
            if (response) {
                dispatch(gpsTokenUrlSuccess(response));
            } else {
            }

        } catch (error) {
        }
    };
}
export function generateToken(code, userId,companyId) {
    return async dispatch => {
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/GenerateAccessToken?code=' + code + '&userId=' + userId+ '&companyId=' + companyId;
            const response = await getIntSvcAxios(url, { params: params });
            if (response) {
                dispatch(setGmbLoading(false));
            } else {
            }

        } catch (error) {
        }
    };
}

export function generateGPSToken(code) {
    return async dispatch => {
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/GenerateGPSAccessToken?code=' + code ;
            const response = await getIntSvcAxios(url, { params: params });
            if (response) {
                localStorage.setItem('gpsAuthentication',response.statusCode===200);
                window.open("/#/settings/addLocations", "_self")
              //  dispatch(getGPSTokenSucess(response));
            } else {
            }

        } catch (error) {
        }
    };
}
export function removeToken(accountId,companyId) {
    return async dispatch => {
        try {
            const params = { callTime: new Date() };
            const url = 'GmbSvc/gmb/RemoveAccount?accountId=' + accountId +'&companyId='+companyId
            const response = await getIntSvcAxios(url, { params: params });
            if (response) {
                window.location.reload();

            } else {
            }

        } catch (error) {
        }
    };
}


export function deleteReviewReply(accountId, locationId, reviewId, userId) {
    return async dispatch => {
        try {
            const params = { accountId, locationId, reviewId, userId }
            const url = 'GmbSvc/gmb/DeleteReviewReply'
            const response = await postIntSvcAxios(url, { params: params });
            if (response) { 
            } else {
            }

        } catch (error) {
        }
    };
}


export const checkCompanyToken = () => {
    return async dispatch => { 
        try {
            const params = { callTime: new Date() }
            const url = 'GmbSvc/gmb/CheckCompanyToken'
            const response = await getIntSvcAxios(url,  { params:  params });
            if(response)
            {
                dispatch(checkCompanyTokenSuccess(response));
            }
          
        } catch (error) {
             
        }
    }
};

export const getLocation = (accountId,locationId) => {
    return async dispatch => { 
        dispatch(setLocation());
        try {
            const params = { callTime: new Date() }
            const url = 'GmbSvc/GMB/GetLocationDetails?accountId='+accountId+'&locationId='+locationId
            const response = await getIntSvcAxios(url,  { params:  params });
            dispatch(getLocationSucess(response));
        } catch (error) {
             
        }
    }
};


export const getCategories = (regionCode) => {
    return async dispatch => { 
        dispatch(setLocation());
        try {
            const params = { callTime: new Date() }
            const url = 'GmbSvc/GMB/GetBusinessCategories?regionCode='+regionCode 
            const response = await getIntSvcAxios(url,  { params:  params });
            dispatch(getCategoriesSuccsess(response));
        } catch (error) {
             
        }
    }
};